export function getLanguageOnlyFromLocale(locale) {
    return locale.split(/[-_]/)[0];
}
//# sourceMappingURL=utils.js.map